<template>
  <div
    :class="[
      'BINGO_container',
      BingoValue == 5 ? 'won' : '',
      gameCompleted && !isIamNewPlayer ? 'gameCompleted' : ''
    ]"
  >
    <span :class="['bingoLetter', BingoValue >= 1 ? 'coloured' : '']">B</span>
    <span :class="['bingoLetter', BingoValue >= 2 ? 'coloured' : '']">I</span>
    <span :class="['bingoLetter', BingoValue >= 3 ? 'coloured' : '']">N</span>
    <span :class="['bingoLetter', BingoValue >= 4 ? 'coloured' : '']">G</span>
    <span :class="['bingoLetter', BingoValue >= 5 ? 'coloured' : '']">O</span>
  </div>
</template>
<script>
import store from "@/store";
export default {
  computed: {
    BingoValue: () => store.getters.BingoValue,
    gameCompleted: () => store.getters.gameCompleted,
    isIamNewPlayer: () => store.getters.isIamNewPlayer
  },watch:{
    BingoValue(newValue){
      if(this.gameCompleted && newValue<5){
        store.dispatch('playSound','losser');
        return;
      }
      if(this.gameCompleted && newValue>=5){
        store.dispatch('playSound','winner');
        return;
      }   
      if(newValue>0 && newValue<5){
        store.dispatch('playSound','longStrike');
      }
    }
  }
};
</script>
